// component/elements/ImageUploader.jsx
import React, { useState } from "react";
import { FiUploadCloud } from "react-icons/fi";
import axiosInstance from "../configuration/request";
import { useSnackbar } from "./SnackbarContext";


export default function ImageUploader({ value, onChange }) {
  const showSnackbar = useSnackbar();
  const [uploading, setUploading] = useState(false);

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const maxFileSize = 5 * 1024 * 1024; // 1 MB limit
    if (file.size > maxFileSize) {
      showSnackbar("File must be less than 5 MB", "error");
      return;
    }

    try {
      setUploading(true);
      const formData = new FormData();
      formData.append("file", file);

      const response = await axiosInstance.post("/customer/upload/file", formData);
      const fileUrl = response.data?.url || "";

      if (fileUrl) {
        onChange(fileUrl); // Pass back to parent
        showSnackbar("Image uploaded successfully", "success");
      }
    } catch (error) {
      console.error(error);
      showSnackbar("Failed to upload image", "error");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <label className="block text-gray-700 text-sm font-medium mb-1">
        Upload Image
      </label>

      <div className="relative border-2 border-dashed border-gray-300 rounded-xl p-4 flex flex-col items-center justify-center cursor-pointer hover:border-[#3383B2] hover:bg-[#f9fbfc] transition">
        <FiUploadCloud className="h-10 w-10 text-gray-400 mb-2" />
        <p className="text-xs text-gray-500">
          {uploading ? "Uploading..." : "Click to upload"}
        </p>
        <input
          type="file"
          accept="image/*"
          onChange={handleImageUpload}
          className="absolute inset-0 opacity-0 cursor-pointer"
        />
      </div>

      {value && (
        <div className="mt-3 flex items-center gap-3">
          <img
            src={value}
            alt="Preview"
            className="h-20 w-20 rounded-md object-cover border border-gray-300"
          />
        </div>
      )}
    </div>
  );
}
